import dayjs, { type Dayjs } from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

export const GENERIC_DATE_TIME_FORMAT = "DD.MM.YYYY, HH:mm";

export const formatGenericDateTime = (value: Dayjs | null): string =>
  dayjs.isDayjs(value) && value.isValid()
    ? value.format(GENERIC_DATE_TIME_FORMAT)
    : "";

export const parseGenericDateTime = (text: string): Dayjs | null => {
  const trimmed = text.trim();
  if (!trimmed) {
    return null;
  }

  const parsed = dayjs(trimmed, GENERIC_DATE_TIME_FORMAT, true);
  return parsed.isValid() ? parsed : null;
};

export const combineDateAndTime = (
  date: Dayjs,
  hour: number,
  minute: number,
  preserveHiddenTimeFrom?: Dayjs | null,
): Dayjs => {
  const base =
    dayjs.isDayjs(preserveHiddenTimeFrom) && preserveHiddenTimeFrom.isValid()
    ? preserveHiddenTimeFrom
    : date.second(0).millisecond(0);

  return base
    .year(date.year())
    .month(date.month())
    .date(date.date())
    .hour(hour)
    .minute(minute);
};
